export type KalshiBalanceScope = 'org' | 'user' | null | undefined;

function finiteNumber(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim()) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

/** Read the venue-reported cash field without assigning unproven semantics. */
export function readKalshiReportedBalanceCents(payload: Record<string, unknown>): number | null {
  return finiteNumber(payload.balance) ?? finiteNumber(payload.available_balance);
}

/**
 * Hover contract shared by every compact Kalshi balance readout.
 *
 * A live personal-account sample proved that Kalshi's `balance` did not fall
 * when a resting order reserved cash. The org/entity scope is still being
 * measured, so the UI must describe provenance and scope without calling the
 * value "available" or "net of holds".
 */
export function kalshiReportedBalanceTitle(scope: KalshiBalanceScope): string {
  const subject = scope === 'org'
    ? 'organization-credential account'
    : scope === 'user'
      ? 'personal account'
      : 'account';
  return `Kalshi ${subject} balance as reported by Kalshi. G1 applies no hold math; do not read this as a member allocation or an available-after-order-holds figure.`;
}
